'use client';

import { useSearch } from '@lib/swr/hooks/search';
import { Center, Loader, Pagination, TextInput } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { IconSearch } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import UserNavLink from './UserNavLink';

export default function UserSearch({ fallback = [] }) {
  const [activePage, setPage] = useState(1);
  const [text, setText] = useState<string>('');
  const [debounced] = useDebouncedValue(text, 200);
  const { results, isLoading, isError } = useSearch('users', debounced);

  const pageSize = 10;

  useEffect(() => {
    setPage(1);
  }, [results]);

  return (
    <>
      <TextInput
        mb='xs'
        size='sm'
        type='search'
        placeholder='Search for a climber'
        value={text}
        onChange={(event) => setText(event.currentTarget.value)}
        leftSection={<IconSearch size={16} />}
        rightSection={isLoading && <Loader size='xs' />}
        error={isError}
      />

      {results?.length === 0 && !isLoading && text && <p>No results</p>}
      {results?.length > 0 &&
        results
          .slice((activePage - 1) * pageSize, activePage * pageSize)
          .map((result) => <UserNavLink user={result} key={result._id} />)}

      {!text &&
        fallback
          .slice((activePage - 1) * pageSize, activePage * pageSize)
          .map((result) => <UserNavLink user={result} key={result._id} />)}
      <Center pb='xl'>
        <Pagination
          my='xs'
          value={activePage}
          onChange={setPage}
          total={
            results?.length > 0
              ? Math.ceil(results?.length / pageSize)
              : Math.ceil(fallback?.length / pageSize)
          }
        />
      </Center>
    </>
  );
}
